<div class="panneau-dossier-patient-succes__container">
	<div class="container__content">
		<lua-icone
			[isIcon]="true"
			[customIconName]="gender || 'homme'" 
			[color]="genderColor"
			height="60px"
			width="60px"
  		></lua-icone>
		<h1>{{nameString}}</h1>
		<small>{{birthDateString}}</small>
		<p>{{nouveauPatient ? 'Dossier patient créé !' : 'Dossier patient mis à jour !'}}</p>
		<lua-action-secondaire libelle="Ouvrir le dossier" (click)="openDossierPatient()" [fullWidth]="true" size="large"></lua-action-secondaire>
	</div>
</div>
